(function(){
    'use strict'

    angular
    .module('app.accionesPersonal')
    .controller('EditarAccionPersonal', EditarAccionPersonal);

    EditarAccionPersonal.$inject = ['moment', '$q', '$scope', '$animationsSrv', '$routeParams','AccionesPersonalService', 'logger', '$location', 'UserInfoService', 'TiposAccionPersonalService', 'EmpleadosService', 'ArchivoCCSSService'];

    function EditarAccionPersonal(moment, $q, $scope, $animationsSrv, $routeParams, AccionesPersonalService, logger, $location, UserInfoService, TiposAccionPersonalService, EmpleadosService, ArchivoCCSSService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.tipos = [];
        vm.tiposPermisoCCSS = [];
        vm.tiposIncapacidadCCSS = [];
        vm.filterData = [];
        vm.empleados = [];

        vm.accionPersonal = {
            companiaId: UserInfoService.getCompaniaId(),
            tipo: -1,
            fecha: moment().toDate(),
            empleadoId: '',
            empleadoNombre: '',
            tipoAusencia: -1,
            tipoPermisoCCSS: -1,
            tipoIncapacidadCCSS: -1,
            asociarExclusionCCSS: false,
            asociarInclusionCCSS: false
        };

        vm.busquedaEmpleado = {
            puestoId: -1,
            departamentoId: -1,
            tipoPlanillaId: -1,
            nombre: '',
            identificacion: '',
            companiaId: UserInfoService.getCompaniaId(),
            estado: -1
        };

        vm.accionPersonalId = $routeParams.id ? $routeParams.id : 0;

        vm.openModalEmpleados = function(){
            if(vm.empleados.length > 0){
                $('#myModalEmpleados').modal('toggle');   
            }
            else{
                var promise = EmpleadosService.getAll(vm.busquedaEmpleado);

                promise
                .then(function(result){
                    vm.empleados = result.data;
                    $('#myModalEmpleados').modal('toggle'); 
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sessión ha terminado.');
                            break;
                    
                        default:
                            logger.error('Error al obtener los empleados.');
                            break;
                    }
                });
            }
             
        };

        vm.seleccionarEmpleado = function(e){
            vm.accionPersonal.empleadoId = e.id;
            vm.accionPersonal.empleadoNombre = e.nombre;
            vm.accionPersonal.salario = Number(e.montoSalarioPromedio.toFixed(2));
            $scope.accionPersonalForm.empleadoId.$dirty = true;
            $scope.accionPersonalForm.$dirty = true;
            $('#myModalEmpleados').modal('toggle');   
        };

        var promiseTipos = getTipos();
        var promiseTiposIncapacidadCCSS = getTiposPermisoCCSS();
        var promiseTiposPermisoCCSS = getTiposIncapacidadCCSS();

        CargarAccionPersonal();

        function getTipos(){
            var promise = TiposAccionPersonalService.getAll(UserInfoService.getCompaniaId())
            .then(function(tipos){
                vm.tipos = tipos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos.');
            }); 
            
            return promise;
        };

        function getTiposPermisoCCSS(){
            var promise = ArchivoCCSSService.getTiposPermiso()
            .then(function(tipos){
                vm.tiposPermisoCCSS = tipos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de permiso.');
            }); 
            
            return promise;
        };

        function getTiposIncapacidadCCSS(){
            var promise = ArchivoCCSSService.getTiposIncapacidad()
            .then(function(tipos){
                vm.tiposIncapacidadCCSS = tipos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de incapacidad.');
            }); 
            
            return promise;
        };

        function CargarAccionPersonal(){
            $q.all([promiseTipos, promiseTiposIncapacidadCCSS, promiseTiposPermisoCCSS]).then(getAccionPersonal);
        }

        function getAccionPersonal(){

            if(vm.accionPersonalId != 0){
                var promise = AccionesPersonalService.getById(vm.accionPersonalId);

                promise
                .then(function(accionPersonal){
                    accionPersonal.fechaDesde = accionPersonal.fechaDesde == null ? null : moment(accionPersonal.fechaDesde).toDate();
                    accionPersonal.fechaHasta = accionPersonal.fechaHasta == null ? null : moment(accionPersonal.fechaHasta).toDate();
                    accionPersonal.tipoAusencia = accionPersonal.tipoAusencia == null ? -1 : accionPersonal.tipoAusencia;
                    accionPersonal.tipoPermisoCCSS = accionPersonal.tipoPermisoCCSS == null ? -1 : accionPersonal.tipoPermisoCCSS;
                    accionPersonal.tipoIncapacidadCCSS = accionPersonal.tipoIncapacidadCCSS == null ? -1 : accionPersonal.tipoIncapacidadCCSS;
                    accionPersonal.fecha = moment(accionPersonal.fecha).toDate();
                    vm.accionPersonal = accionPersonal;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener la accion de personal: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        function validateFechaHasta(){
            if(!vm.accionPersonal.fechaHasta && (!vm.esDespido() && !vm.esRenuncia())){
                $scope.accionPersonalForm.fechaHasta.$setValidity("required", false);
            }
            else{
                $scope.accionPersonalForm.fechaHasta.$setValidity("required", true);
            }
        };

        function validateFecha(){
            if(!vm.accionPersonal.fecha){
                $scope.accionPersonalForm.fecha.$setValidity("required", false);
            }
            else{
                $scope.accionPersonalForm.fecha.$setValidity("required", true);
            }
        };

        function doFormValidations(){
            validateTipo();
            validateFechaHasta();
            validateFecha();
            validateTipoIncapacidadCCSS();
            validateTipoPermisoCCSS();
        };

        vm.save = function(){

            $scope.submitted = true;
            $animationsSrv.scrollToTop();
            doFormValidations();

            if($scope.accionPersonalForm.$valid){
                if(!vm.accionPersonal.id){
                    saveAccionPersonal();
                }
                else if($scope.accionPersonalForm.$dirty){
                    updateAccionPersonal();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveAccionPersonal() {
            if(vm.accionPersonal.tipoAusencia == -1){
                vm.accionPersonal.tipoAusencia = null;
            }
            if(vm.accionPersonal.tipoIncapacidadCCSS == -1){
                vm.accionPersonal.tipoIncapacidadCCSS = null;
            }
            if(vm.accionPersonal.tipoPermisoCCSS == -1){
                vm.accionPersonal.tipoPermisoCCSS = null;
            }

            var promise = AccionesPersonalService.save(vm.accionPersonal);
            
            promise
            .then(function(response){
                logger.success('Accion de Personal creada con éxito.');
                clearAccionPersonalData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear la accion de personal: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateAccionPersonal(){
            if(vm.accionPersonal.tipoAusencia == -1){
                vm.accionPersonal.tipoAusencia = null;
            }
            if(vm.accionPersonal.tipoIncapacidadCCSS == -1){
                vm.accionPersonal.tipoIncapacidadCCSS = null;
            }
            if(vm.accionPersonal.tipoPermisoCCSS == -1){
                vm.accionPersonal.tipoPermisoCCSS = null;
            }

            var promise = AccionesPersonalService.update(vm.accionPersonal);
            
            promise
            .then(function(response){
                logger.success('Accion Personal modificada con éxito.');
                $location.path('/acciones-personal');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar la accion de personal: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearAccionPersonalData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.accionPersonal = {
                companiaId: UserInfoService.getCompaniaId(),
                tipo: -1,
                fecha: moment().toDate(),
                empleadoId: '',
                empleadoNombre: '',
                tipoAusencia: -1,
                tipoPermisoCCSS: -1,
                tipoIncapacidadCCSS: -1,
                asociarExclusionCCSS: false,
                asociarInclusionCCSS: false
            };
            // Set back to pristine.
            $scope.accionPersonalForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.accionPersonalForm.$setUntouched();
        };

        vm.tiposChange = function(){
            validateTipo();
        };

        function validateTipo(){
            if(vm.accionPersonal.tipo == -1){
                $scope.accionPersonalForm.tipo.$setValidity("different", false);
            }
            else{
                $scope.accionPersonalForm.tipo.$setValidity("different", true);
            }
        }

        vm.tiposIncapacidadCCSSChange = function(){
            validateTipoIncapacidadCCSS();
        };

        function validateTipoIncapacidadCCSS(){
            if(vm.esIncapacidad() && vm.accionPersonal.tipoIncapacidadCCSS == -1){
                $scope.accionPersonalForm.tipoIncapacidadCCSS.$setValidity("different", false);
            }
            else{
                $scope.accionPersonalForm.tipoIncapacidadCCSS.$setValidity("different", true);
            }
        }

        vm.tiposPermisoCCSSChange = function(){
            validateTipoPermisoCCSS();
        };

        function validateTipoPermisoCCSS(){
            if(vm.esPermiso() && vm.accionPersonal.tipoPermisoCCSS == -1){
                $scope.accionPersonalForm.tipoPermisoCCSS.$setValidity("different", false);
            }
            else{
                $scope.accionPersonalForm.tipoPermisoCCSS.$setValidity("different", true);
            }
        }

        vm.filterEmpleados = function(){
            vm.filterData = vm.empleados.filter(function(g) {
                return (g.id.toString().indexOf(vm.busquedaEmpleado.id) >= 0 || !vm.busquedaEmpleado.id) && 
                (g.nombre.toLowerCase().indexOf(vm.busquedaEmpleado.nombre.toLowerCase()) >= 0 || !vm.busquedaEmpleado.nombre);
            }).slice(0, 100);
        };

        vm.fechaOptions = {
            showWeeks: true
        };

        vm.fechaDesdeOptions = {
            showWeeks: true
        };

        vm.openFechaDesde = function(){
            vm.fechaDesdeOpened = !vm.fechaDesdeOpened;
        };

        vm.fechaHastaOptions = {
            showWeeks: true
        };

        vm.openFechaHasta = function(){
            vm.fechaHastaOpened = !vm.fechaHastaOpened;
        };

        function getTipoAccionPersonalByPrefijo(prefijo){
            var tipo = vm.tipos.filter(function(el){
                return el.prefijo == prefijo;
            });

            if(!tipo[0]) return 0;

            return tipo[0].id;
        };

        vm.esNuevoIngreso = function(){
            return vm.accionPersonal.tipo == getTipoAccionPersonalByPrefijo('NUE');
        };

        vm.esDespido = function(){
            return vm.accionPersonal.tipo == getTipoAccionPersonalByPrefijo('DES');
        }

        vm.esRenuncia = function(){
            return vm.accionPersonal.tipo == getTipoAccionPersonalByPrefijo('REN');
        }

        vm.esAumento = function(){
            return vm.accionPersonal.tipo == getTipoAccionPersonalByPrefijo('AUM');
        }

        vm.esPermiso = function(){
            return vm.accionPersonal.tipo == getTipoAccionPersonalByPrefijo('PER');
        }

        vm.esIncapacidad = function(){
            return vm.accionPersonal.tipo == getTipoAccionPersonalByPrefijo('INC');
        }

    }
})();